import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import { ITransactionItem, ITransactions, ITransactionSettings } from '../../interfaces/transactions.interfaces';

export interface ITransactionsState {
  transactionsList: ITransactionItem[],
  settings: ITransactionSettings,
  total: number;
  total_all: number | null;
  isFirstLoad: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: ITransactionsState = {
  transactionsList: [],
  settings: {
    limit: 10,
    offset: 0,
  },
  total: 0,
  total_all: null,
  isFirstLoad: true,
  loading: false,
  error: null
};

export const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    getTransactionsRequest(state, { payload: { isFirstLoad } }: PayloadAction<{ isFirstLoad: boolean }>) {
      state.loading = true;
      state.isFirstLoad = isFirstLoad;
      state.error = null;
    },
    getTransactionsRequestSuccess: (state, { payload }: PayloadAction<ITransactions>) => {
      state.transactionsList = payload.transactions ?? [];
      state.total = payload.total ?? 0;
      state.total_all = payload.total_all ?? 0;
      state.loading = false;
      state.isFirstLoad = false;
      state.error = null;
    },
    getTransactionsRequestFailure: (state, { payload: error }: PayloadAction<string>) => {
      state.loading = false;
      state.isFirstLoad = false;
      state.error = error;
    },
    setSettings(state, { payload }: PayloadAction<ITransactionSettings>) {
      state.settings = payload;
    },
    setIsFirstLoadTransactions: (state, { payload: { isFirstLoad } }: PayloadAction<{ isFirstLoad: boolean }>) => {
      state.isFirstLoad = isFirstLoad;
    },
    updateTransactionInfo: (state, { payload: id }: PayloadAction<number>) => {
      state.transactionsList = state.transactionsList.map(transaction => {
        if (transaction.id === id) {
          return { ...transaction, refund_status: 'requested', is_refund_requested: true };
        }
        return transaction;
      })
    },
    changeTransactionsRecordingData: (state, { payload: { transaction_id, has_recording_till } }: PayloadAction<{ transaction_id: number, has_recording_till: string }>) => {
      state.transactionsList = state.transactionsList.map(transaction => {
        if (transaction.id === transaction_id) {
          return { ...transaction, has_recording: true, has_recording_till };
        }
        return transaction;
      })
    },
    clearTransactions: (state) => {
      state.transactionsList = [];
      state.isFirstLoad = true;
      state.loading = true;
    }
  }
});

export const TransactionsSliceActions = transactionsSlice.actions;
